import React from 'react';
import { ChevronLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import './BackButton.css';

// Bouton « ‹ Retour » commun aux écrans d'entrée des jeux de Pratiquer
// (même style que l'écran de choix de thème du Quiz culturel).
interface BackButtonProps {
  onClick: () => void;
  label?: string;
  className?: string;
  style?: React.CSSProperties;
}

const BackButton: React.FC<BackButtonProps> = ({ onClick, label, className, style }) => {
  const { t } = useTranslation();
  const text = label ?? (t('miniGames.back', 'Retour') as string);
  return (
    <button type="button" className={`jg-back${className ? ` ${className}` : ''}`} onClick={onClick} style={style}>
      <ChevronLeft size={20} strokeWidth={2} aria-hidden="true" />
      <span>{text}</span>
    </button>
  );
};

export default BackButton;
